var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t9"},[(_vm.isHuafa)?_c('T9HF'):(_vm.isZd)?_c('T9ZD'):(_vm.isSf)?_c('T9SF'):(_vm.isAlej)?_c('T9ALEJ'):(_vm.isLfs)?_c('T9LFS'):_c('T9DEFAULT')],1)}
var staticRenderFns = []

export { render, staticRenderFns }